import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "./addBlItemPage.scss";
import { getImageUrl, getImageName } from "../../api/iposApi";
import ItemInfo from "../../components/ItemInfo";
import ItemQuantity from "../../components/ItemQuantiry";
import ItemAddToCardBtn from "../../components/ItemAddToCardBtn";
import { generateOrderItem } from "../../helpers/common";
import { withTranslation } from "react-i18next";
import BlCategoriesList from "./components/BlCategoriesList";
import IPosModal from "../../IPosModal";
import { loadMenuItemSupplements } from "../../redux/actions/menuActions";
import {
  addToOrder,
  cancelSelection,
  deleteOrderItem,
} from "../../redux/actions/orderActions";
import { useHistory } from "react-router-dom";
import BlItemToCartInfo from "./components/BlItemToCartInfo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { hideLoading, showLoading } from "../../redux/actions/loadingActions";

//ForceUpdate hook
function useForceUpdate() {
  const [value, setValue] = useState(0); // integer state
  return () => setValue((value) => value + 1); // update the state to force render
}

const AddBlItemPage = (props) => {
  const {
    selectedItem,
    currentOrderItem,
    menuItemTypes,
    currentLanguageId,
    t,
    loadMenuItemSupplements,
    addToOrder,
    cancelSelection,
    selectedBusinessLunch,
    deleteOrderItem,
    showLoading,
    hideLoading,
    branchInfo,
  } = props;
  const [orderItem, updateOrderItem] = useState(
    currentOrderItem
      ? currentOrderItem
      : selectedItem
      ? generateOrderItem(selectedItem, menuItemTypes)
      : null
  );
  const [blItems, setBlItems] = useState(orderItem.lunchItems || []);
  const [currentQuantity, setCurrentQuantity] = useState(
    currentOrderItem ? currentOrderItem.orderItem.quantity : 1
  );
  //const isMobile = isMobileAndTablet();

  const forceUpdate = useForceUpdate();

  const history = useHistory();

  // useEffect(() => {
  //   // showLoading();
  // }, []);

  useEffect(() => {
    orderItem.lunchItems = blItems;
    updateOrderItem(orderItem);
    forceUpdate();
    // hideLoading();
  }, [blItems]);

  useEffect(() => {
    forceUpdate();
  }, [orderItem]);

  useEffect(() => {
    if (!currentOrderItem) {
      return;
    }
    updateOrderItem(currentOrderItem);
    setBlItems(currentOrderItem.lunchItems);
  }, [currentOrderItem]);

  useEffect(() => {
    const tmpItem = Object.assign({}, orderItem);
    tmpItem.orderItem.quantity = currentQuantity;

    for (const lunchItem of tmpItem.lunchItems) {
      lunchItem.orderItem.quantity = currentQuantity;
      for (const supplement of lunchItem.supplements) {
        supplement.orderItem.quantity = currentQuantity;
      }
    }

    updateOrderItem(tmpItem);
    setBlItems(tmpItem.lunchItems);
  }, [currentQuantity]);

  const updateBlItems = (blItem) => {
    if (
      blItems.some(
        (i) => i.menuItem.menu_item_id === blItem.menuItem.menu_item_id
      )
    ) {
      if (blItem.noAdditions) {
        deleteBlItem(blItem);
      } else {
        const updatedState = blItems.map((item) => {
          if (item.menuItem.menu_item_id === blItem.menuItem.menu_item_id) {
            return Object.assign({}, blItem);
          }
          return item;
        });
        setBlItems([...updatedState]);
      }
    } else {
      setBlItems([...blItems, blItem]);
    }
  };

  const deleteBlItem = (blItem) => {
    setBlItems(
      blItems.filter(
        (i) => i.menuItem.menu_item_id !== blItem.menuItem.menu_item_id
      )
    );
  };

  const onSelectBlItem = (menuItem, category, relation) => {
    const existingLunchItem = blItems.find(
      (i) => i.menuItem.menu_item_id === menuItem.menu_item_id
    );

    const [maxQtyValid, maxQtyError] = validateMaxCommonQty(1);

    if (!maxQtyValid && !existingLunchItem) {
      showAlert(maxQtyError);
      return;
    }

    const [maxCategoryQtyValid, maxCategoryQtyError] = validateMaxCategoryQty(
      relation.category_item_id,
      1
    );

    if (!maxCategoryQtyValid && !existingLunchItem) {
      showAlert(maxCategoryQtyError);
      return;
    }

    loadMenuItemSupplements(menuItem.menu_item_id).then(
      ([supplements, instructions]) => {
        const noAdditions =
          (!supplements || supplements.length === 0) &&
          (!instructions || instructions.length === 0);

        if (noAdditions) {
          if (existingLunchItem) {
            updateBlItems(existingLunchItem);
          } else {
            updateBlItems(
              generateOrderItem(menuItem, menuItemTypes, {
                noAdditions: true,
                category: category,
                relation: relation,
              })
            );
          }
        } else {
          IPosModal.addItemModal(
            {
              menuItem: menuItem,
              category: category,
              relation: relation,
              currentOrderItem: existingLunchItem,
              t: t,
              isRtl: currentLanguageId === 2,
              selectedItemSupplements: supplements,
              itemInstructions: instructions,
              menuItemTypes: menuItemTypes,
              onlyAdditions: false,
              branchInfo: branchInfo,
              onOk: (lunchItem) => {
                updateBlItems(lunchItem);
              },
              onDelete: (lunchItem) => {
                deleteBlItem(lunchItem);
              },
              onClose: () => {},
            },
            {}
          );
        }
      }
    );
  };

  // Validations [START]
  const maxItemsCount =
    orderItem.menuItem.max_childs_count * orderItem.orderItem.quantity;

  const validateMaxCommonQty = (quantity) => {
    const existingItemsCount = blItems.reduce((acc, curr) => {
      const sum = acc + curr.orderItem.quantity;
      return sum;
    }, quantity);

    return existingItemsCount > maxItemsCount
      ? [false, t("bl.max_items_error", { maxItemsCount: maxItemsCount })]
      : [true, ""];
  };

  const validateItemsPresence = () => {
    return blItems.length === 0
      ? [false, t("bl.bl_not_empty_error")]
      : [true, ""];
  };

  const getItemsQtyInCategory = (categoryId, quantity) => {
    return blItems.reduce((acc, curr) => {
      if (curr.relation.category_item_id === categoryId) {
        return acc + curr.orderItem.quantity;
      }
      return acc;
    }, quantity);
  };

  const validateMinCategoryQty = () => {
    let denieAddItemFromCategory = false;

    selectedBusinessLunch.category_relations.forEach((relation) => {
      if (relation.min_qty > 0) {
        const existingItemsFromCategoryCount = getItemsQtyInCategory(
          relation.menu_item_id,
          0
        );

        denieAddItemFromCategory =
          denieAddItemFromCategory ||
          existingItemsFromCategoryCount <
            relation.min_qty * orderItem.orderItem.quantity;
      }
    });

    return denieAddItemFromCategory
      ? [false, t("bl.min_items_error")]
      : [true, ""];
  };

  const validateMaxCategoryQty = (category_item_id, quantity) => {
    let denieAddItemFromCategory = false;

    selectedBusinessLunch.category_relations.forEach((relation) => {
      if (relation.menu_item_id === category_item_id) {
        const existingItemsFromCategoryCount = getItemsQtyInCategory(
          category_item_id,
          quantity
        );
        denieAddItemFromCategory =
          denieAddItemFromCategory ||
          existingItemsFromCategoryCount >
            relation.max_qty * orderItem.orderItem.quantity;
      }
    });

    return denieAddItemFromCategory
      ? [false, t("bl.category_items_error")]
      : [true, ""];
  };

  const validate = () => {
    const [valid, errorMessage] = validateItemsPresence();
    if (!valid) {
      return [false, errorMessage];
    }

    const [validMin, errorMinMessage] = validateMinCategoryQty();
    if (!validMin) {
      return [false, errorMinMessage];
    }
    return [true, ""];
  };

  // Validations [END]

  const addBlToCart = () => {
    const [valid, error] = validate();
    if (!valid) {
      showAlert(error);
      return;
    }

    addToOrder(orderItem);
    goToMenu();
  };

  const goToMenu = () => {
    cancelSelection();
    history.goBack();
  };

  const destory = () => {
    IPosModal.confirmation({
      title: t("dialogs.destroying_item", {
        name: orderItem.menuItem.item_name,
      }),
      message: t("dialogs.are_you_sure"),
      okButtonText: t("buttons.delete"),
      cancelButtonText: t("buttons.cancel"),
      onOk: () => {
        deleteOrderItem(orderItem);
        goToMenu();
      },
      onClose: () => {},
    });
  };

  const showAlert = (message) => {
    IPosModal.alert({
      title: t("add_item_modal.errors.title"),
      message: message,
      okButtonText: t("buttons.ok"),
      cancelButtonText: t("buttons.cancel"),
      onOk: () => {},
    });
  };

  const mobileLayout = () => {
    return (
      <div className={"add-bl-item-page mobile-layout"}>
        <div className="container">
          <div className={"item-side-bar"}>
            <div className={"side-bar-content"}>
              <div
                className={"close-modal"}
                onClick={() => {
                  goToMenu();
                }}
              >
                <FontAwesomeIcon icon="chevron-down" />
              </div>
              <div className={"dialog-item-info"}>
                <img
                  src={getImageUrl(getImageName(branchInfo, orderItem.menuItem), true)}
                  className="img-responsive"
                  alt="iPos Web Delivery"
                  onClick={() => {
                    //if (isMobile) {
                    goToMenu();
                    //}
                  }}
                />
                <ItemInfo
                  orderItem={orderItem}
                  currentLanguageId={currentLanguageId}
                />
              </div>

              {branchInfo.use_pin_pad_flg === 0 && (
                <div className={"bl-selected-items"}>
                  <BlItemToCartInfo blItems={blItems} t={t} />
                </div>
              )}
              <div className={"add-item-actions"}>
                <ItemQuantity
                  item={orderItem}
                  currentQuantity={currentQuantity}
                  updateQuantity={setCurrentQuantity}
                />
                <div className={"action-buttons"}>
                  {/* {currentOrderItem && (
                    <div className={"btn btn-danger"} onClick={destory}>
                      <FontAwesomeIcon icon={"trash"} />
                    </div>
                  )} */}
                  <ItemAddToCardBtn
                    t={t}
                    orderItem={orderItem}
                    isNewItem={currentOrderItem === null}
                    onAddToCart={addBlToCart}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className={"item-content"}>
            <BlCategoriesList
              addBlItem={onSelectBlItem}
              selectedItems={blItems}
            />
          </div>
        </div>
      </div>
    );
  };

  return <>{mobileLayout()}</>;
};

const mapStateToProps = (state) => {
  const {
    selectedItem,
    branchInfo,
    menuItemTypes,
    selectedItemSupplements,
    selectedItemInstructions,
    selectedBusinessLunch,
    currentLanguageId,
    currentOrderItem,
  } = state;

  return {
    selectedItem,
    branchInfo,
    menuItemTypes,
    selectedItemSupplements,
    selectedItemInstructions,
    selectedBusinessLunch,
    currentLanguageId,
    currentOrderItem,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      loadMenuItemSupplements,
      addToOrder,
      cancelSelection,
      deleteOrderItem,
      showLoading,
      hideLoading,
    },
    dispatch
  );
export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(AddBlItemPage)
);
